
namespace Gamification.Gamification {
    export class UtentiProdottiParametriGlobaliColumns {
        static columnsKey = 'Gamification.UtentiProdottiParametriGlobali';
    }
}